"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _toolbar = _interopRequireDefault(require("./toolbar"));

var _templateObject;

var VerticalToolbar = (0, _styledComponents["default"])(_toolbar["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  flex-direction: column;\n\n  .toolbar-item {\n    width: 78px;\n    padding: 13px 16px;\n  }\n"])));
VerticalToolbar.displayName = 'VerticalToolbar';
var _default = VerticalToolbar;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21tb24vdmVydGljYWwtdG9vbGJhci50c3giXSwibmFtZXMiOlsiVmVydGljYWxUb29sYmFyIiwiVG9vbGJhciIsImRpc3BsYXlOYW1lIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7OztBQUdBOztBQUNBOzs7O0FBRUEsSUFBTUEsZUFBZSxHQUFHLGtDQUFPQyxtQkFBUCxDQUFILHdMQUFyQjtBQVNBRCxlQUFlLENBQUNFLFdBQWhCLEdBQThCLGlCQUE5QjtlQUVlRixlIiwic291cmNlc0NvbnRlbnQiOlsiLy8gU1BEWC1MaWNlbnNlLUlkZW50aWZpZXI6IE1JVFxuLy8gQ29weXJpZ2h0IGNvbnRyaWJ1dG9ycyB0byB0aGUga2VwbGVyLmdsIHByb2plY3RcblxuaW1wb3J0IHN0eWxlZCBmcm9tICdzdHlsZWQtY29tcG9uZW50cyc7XG5pbXBvcnQgVG9vbGJhciwge1Rvb2xiYXJQcm9wc30gZnJvbSAnLi90b29sYmFyJztcblxuY29uc3QgVmVydGljYWxUb29sYmFyID0gc3R5bGVkKFRvb2xiYXIpPFRvb2xiYXJQcm9wcz5gXG4gIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG5cbiAgLnRvb2xiYXItaXRlbSB7XG4gICAgd2lkdGg6IDc4cHg7XG4gICAgcGFkZGluZzogMTNweCAxNnB4O1xuICB9XG5gO1xuXG5WZXJ0aWNhbFRvb2xiYXIuZGlzcGxheU5hbWUgPSAnVmVydGljYWxUb29sYmFyJztcblxuZXhwb3J0IGRlZmF1bHQgVmVydGljYWxUb29sYmFyO1xuIl19